import { render, staticRenderFns } from "./CreateAgencyCommission.vue?vue&type=template&id=36917214&"
import script from "./CreateAgencyCommission.vue?vue&type=script&lang=js&"
export * from "./CreateAgencyCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports